import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";

/**
 * The insurance guide used to be a single page at /medical-weight-loss/insurance
 * with in-page anchors. Those sections now live on spoke pages, so any existing
 * link that still carries an old hash is forwarded to the right spoke.
 */
const LEGACY_HASH_MAP: Record<string, string> = {
  medicaid: "/medical-weight-loss/insurance/medicaid-cova",
  "cardinal-care": "/medical-weight-loss/insurance/medicaid-cova",
  cova: "/medical-weight-loss/insurance/medicaid-cova",
  "state-employee": "/medical-weight-loss/insurance/medicaid-cova",
  medicare: "/medical-weight-loss/insurance/medicare-tricare-fehb",
  "medicare-bridge": "/medical-weight-loss/insurance/medicare-tricare-fehb",
  tricare: "/medical-weight-loss/insurance/medicare-tricare-fehb",
  fehb: "/medical-weight-loss/insurance/medicare-tricare-fehb",
  federal: "/medical-weight-loss/insurance/medicare-tricare-fehb",
  commercial: "/medical-weight-loss/insurance/commercial-marketplace",
  employer: "/medical-weight-loss/insurance/commercial-marketplace",
  marketplace: "/medical-weight-loss/insurance/commercial-marketplace",
  sentara: "/medical-weight-loss/insurance/commercial-marketplace",
  pbm: "/medical-weight-loss/insurance/commercial-marketplace",
  medications: "/medical-weight-loss/insurance/commercial-marketplace",
  denied: "/medical-weight-loss/insurance/cash-pay-denials",
  denials: "/medical-weight-loss/insurance/cash-pay-denials",
  appeal: "/medical-weight-loss/insurance/cash-pay-denials",
  cash: "/medical-weight-loss/insurance/cash-pay-denials",
  "cash-pay": "/medical-weight-loss/insurance/cash-pay-denials",
  "self-pay": "/medical-weight-loss/insurance/cash-pay-denials",
  questions: "/medical-weight-loss/insurance/cash-pay-denials",
};

export function LegacyInsuranceHashRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, "").toLowerCase();
    if (!hash) return;
    const to = LEGACY_HASH_MAP[hash];
    if (!to) return;
    navigate({ to, hash, replace: true });
  }, [navigate]);

  return null;
}
